import { FC } from 'react';

import { ReportMetrics, listKeysMetricsVisit, declineCumulativeMetrics as DECLINE_CUMULATIVE, ads_metrics_keys as ADS_METRICS_KEYS } from '../../modal-settings/index';

// Экспорты для обратной совместимости
export const listKeysMetrics = listKeysMetricsVisit;
export const ads_metrics_keys = ADS_METRICS_KEYS;
export const declineCumulativeMetrics = DECLINE_CUMULATIVE;

interface MetricsProps {
    isDisable?: boolean;
    adsGroupsSelected?: boolean;
    adsGroupsAvailable?: boolean;
    setAdsGroupsAvailable?: (value: boolean) => void;
    setAdsGroupsSelected?: (value: boolean) => void;
}

/**
 * Компонент метрик для отчёта по посещениям.
 * Использует общий ReportMetrics с reportType='visit'.
 */
const Metrics: FC<MetricsProps> = (props) => {
    return <ReportMetrics reportType="visit" {...props} />;
};

export default Metrics;
